<app-loader *ngIf="status === 'loading'"></app-loader>
<section>
  <div *ngIf="status === 'confirm'" class="status-confirm">
    <div class="message-container">
      <div class="status-title">Are you sure you want to unsubscribe?</div>
      <div class="notification-message">You will no longer receive updates about your orders.</div>
    </div>
    <div class="action-container">
      <button type="button" class="action-link" (click)="onConfirm()">Unsubscribe</button>
    </div>
  </div>

  <div *ngIf="status === 'error'" class="status-error">
    <div class="icon-container">
      <div><img src="assets/images/error-icon.svg" alt="Error Icon"></div>
    </div>
    <div class="message-container">
      <div class="status-title">Something Went Wrong</div>
      <div class="notification-message">We couldn’t process your request. Please try again later.</div>
    </div>
  </div>

  <div *ngIf="status === 'unsubscribed'" class="status-success">
    <div class="icon-container">
      <div><img src="assets/images/success-icon.svg" alt="Success Icon"></div>
    </div>
    <div class="message-container">
      <div class="status-title">You’ve Been Unsubscribed</div>
      <div class="notification-message">You will no longer receive updates for this and future orders</div>
    </div>
    <div class="resubscribe-prompt">Did you unsubscribe by accident?
      <a class="resubscribe-link" [routerLink]="['/resubscribe']" [queryParams]="{ token: token }">Re-subscribe</a>
    </div>
  </div>
</section>